class ClassKnowMore {

    constructor() {
        this.getObjects = this.getObjects();
    }

    getObjects = () => {
        return {
            name: '',
            email: '',
            phone: '',
            acceptPolicy: false,
            months: '',
        }
    }
}

export default ClassKnowMore;